/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-trailing-spaces */
/* eslint-disable react/jsx-indent */

import React, { useState } from 'react';
import FacebookLogin from 'react-facebook-login';

function Facebook() {
  const [data, setData] = useState([]);

  const responseFacebook = (res) => {
    fetch('https://graph.facebook.com/v11.0/me/accounts', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${res.accessToken}`,
      },
    })
      .then(response => response.json())
      .then((resp) => {
        setData(resp.data);
      });
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '80vh',
    }}
    >
      <h4 style={{ marginBottom: '20px' }}>My CRM Platform</h4>
      <FacebookLogin
        appId="3833192493473837"
        //   autoLoad
        //   fields="name,email,picture"
        //   scope="public_profile,user_friends"
        callback={responseFacebook}
      //   onFailure={value => console.log('failure', value)}
      />
      <div style={{ marginTop: '10px' }}>
        <ul>
          {data.length !== 0 && data.map(item => (
            <li key={item.id} style={{ textDecoration: 'underline', marginBottom: 5, cursor: 'pointer' }}>{item.name}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Facebook;
